var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountDeniedIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64.416,
    height: 64.416,
    rx: 32.208,
    fill: "#F7E2C0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7969 43.7676V44.8379C19.7969 45.4274 20.2742 45.9057 20.8637 45.9057H32.7345",
    stroke: "#1E247E",
    strokeWidth: 0.960859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0977 18.6196H40.2384C40.8279 18.6196 41.3062 19.098 41.3062 19.6875V33.3736",
    stroke: "#1E247E",
    strokeWidth: 0.960859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5781 16.4844H38.0304C38.6199 16.4844 39.0982 16.9627 39.0982 17.5522V35.7224",
    stroke: "#1E247E",
    strokeWidth: 0.960859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7332 43.7666H18.6538C18.0643 43.7666 17.5859 43.2882 17.5859 42.6987V22.1143",
    stroke: "#1E247E",
    strokeWidth: 0.960859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0303 49.8152H35.5314C33.9868 49.8152 32.7344 48.5628 32.7344 47.0181V38.5192C32.7344 36.9746 33.9868 35.7222 35.5314 35.7222H44.0303C45.575 35.7222 46.8274 36.9746 46.8274 38.5192V47.0181C46.8274 48.5628 45.575 49.8152 44.0303 49.8152Z",
    fill: "#DA867D",
    stroke: "#1E247E",
    strokeWidth: 0.960859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4135 40.1401L37.1484 45.4046",
    stroke: "#1E247E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4135 45.4046L37.1484 40.1401",
    stroke: "#1E247E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5859 22.1157L23.2269 16.4844V21.0479C23.2269 21.6374 22.749 22.1152 22.1595 22.1152H17.5859V22.1157Z",
    fill: "#F0C330",
    stroke: "#1E247E",
    strokeWidth: 0.960859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5368 21.6517H26.8139C26.2068 21.6517 25.7148 21.1598 25.7148 20.5527V20.5502C25.7148 19.9431 26.2068 19.4512 26.8139 19.4512H31.5368C32.1439 19.4512 32.6359 19.9431 32.6359 20.5502V20.5527C32.6359 21.1598 32.1439 21.6517 31.5368 21.6517Z",
    fill: "#F0C330",
    stroke: "#1E247E",
    strokeWidth: 0.960859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3828 25.9131H35.3209",
    stroke: "#DA867D",
    strokeWidth: 0.960859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3828 28.8965H35.3209",
    stroke: "#DA867D",
    strokeWidth: 0.960859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7188 31.8784H35.3217",
    stroke: "#DA867D",
    strokeWidth: 0.960859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3828 31.8784H30.357",
    stroke: "#DA867D",
    strokeWidth: 0.960859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3828 34.8579H27.4603",
    stroke: "#DA867D",
    strokeWidth: 0.960859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3828 37.8408H27.4603",
    stroke: "#DA867D",
    strokeWidth: 0.960859,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountDeniedIcon);
export default __webpack_public_path__ + "static/media/AccountDeniedIcon.d9cf279cf54279d8537f5b917fe9701a.svg";
export { ForwardRef as ReactComponent };